import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    Paper
} from "@material-ui/core";
import * as Yup from "yup";
import { BackButton } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    }
});

const SupportClientTypeForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                className={classes.input}
                                name="Key"
                                value={values.Key}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Key && touched.Key)}
                                placeholder={translations["key"] || "Key"}
                                label={translations["key"] || "Key"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                className={classes.input}
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                className={classes.input}
                                type={'number'}
                                name="MajorVersion"
                                value={values.MajorVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MajorVersion && touched.MajorVersion)}
                                placeholder={translations["major_version"] || "Major version"}
                                label={translations["major_version"] || "Major version"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                className={classes.input}
                                type={'number'}
                                name="MinorVersion"
                                value={values.MinorVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.MinorVersion && touched.MinorVersion)}
                                placeholder={translations["minor_version"] || "Minor version"}
                                label={translations["minor_version"] || "Minor version"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                className={classes.input}
                                type={'number'}
                                name="BuildNumber"
                                value={values.BuildNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.BuildNumber && touched.BuildNumber)}
                                placeholder={translations["build_number"] || "Build number"}
                                label={translations["build_number"] || "Build number"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div>
                                {
                                    formSettings.ButtonSubmit ? (
                                        <Button
                                            className={classes.submit}
                                            variant="contained"
                                            color={formSettings.ButtonSubmit.Color}
                                            type="submit"
                                            style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                            disabled={isSubmitting || !(isValid && dirty)}
                                        >
                                            {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                        </Button>
                                    ) : null
                                }
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(SupportClientTypeForm);
